<template>
<div>
    <v-card class="elevation-6">
        <v-card-title class="d-flex justify-space-between align-center">
            <span v-t="title"></span>
            <v-menu offset-y left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn fab small color="primary" v-bind="attrs" v-on="on">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </template>
                <v-list dense>
                    <v-list-item @click="create">
                        <v-list-item-icon><v-icon>mdi-cart</v-icon></v-list-item-icon>
                        <v-list-item-title>Venta</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="devolver">
                        <v-list-item-icon><v-icon>mdi-keyboard-return</v-icon></v-list-item-icon>
                        <v-list-item-title>Devolución</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-card-title>
        <v-card-subtitle v-t="subtitle" />
        <v-card-text>
            <movimiento-list
                ref="list"
                @update="update"
                @show="show"
                @create="create"
                @devolver="devolver"
                @emitir-factura="abrirModalFactura"
            />
        </v-card-text>
    </v-card>

    <movimiento-create v-if="creating"
                    :open="creating"
                    v-on:itemCreated="onItemCreated"
                    v-on:close="creating=false"
    />

    <devolucion-create v-if="devolviendo"
                    :open="devolviendo"
                    v-on:itemCreated="onItemCreated"
                    v-on:close="devolviendo=false"
    />

    <movimiento-update v-if="updating"
                    :open="updating"
                    :item="itemToEdit"
                    v-on:itemUpdated="onItemUpdated"
                    v-on:close="updating=false"
    />

    <movimiento-show v-if="showing"
                    :open="showing"
                    :item="itemToShow"
                    v-on:close="showing=false"
    />

    <FacturaEmitirModal
        v-model="mostrarModalFactura"
        :movimiento="movimientoParaFacturar"
        @factura-emitida="onFacturaEmitida"
        @mensaje="onMensajeFactura"
    />

    <snackbar v-model="flash"/>
</div>
</template>

<script>
    import MovimientoCreate from "../MovimientoCreate";
    import DevolucionCreate from "../DevolucionCreate";
    import MovimientoUpdate from "../MovimientoUpdate";
    import MovimientoShow from "../MovimientoShow";
    import MovimientoList from "../MovimientoList";
    import FacturaEmitirModal from "../../../../facturacion/components/FacturaEmitirModal";
    import MovimientoProvider from "../../../providers/MovimientoProvider";
    import {Snackbar} from "@dracul/common-frontend"

    export default {
        name: "MovimientoCrud",
        components: {
            Snackbar,
            MovimientoCreate,
            DevolucionCreate,
            MovimientoUpdate, 
            MovimientoShow,
            MovimientoList,
            FacturaEmitirModal,
        },
        data() {
            return {
                title: 'movimiento.title',
                subtitle: 'movimiento.subtitle',
                flash: null,
                creating: false,
                devolviendo: false,
                updating: false,
                deleting: false,
                showing: false,
                itemToEdit: null,
                itemToDelete: null,
                itemToShow: null,
                mostrarModalFactura: false,
                movimientoParaFacturar: null,
            }
        },
        methods: {
            //On
            onItemCreated(movimiento) {
                this.$refs.list.fetch()
                this.flash= this.$t("common.created")
                
                // Abrir modal de facturación después de crear venta o devolución
                if (movimiento && (movimiento.tipo === 'VENTA' || movimiento.tipo === 'DEVOLUCION')) {
                    this.intentarAbrirModalFactura(movimiento)
                }
            },
            onItemUpdated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.updated")
            },
            onItemDeleted() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.deleted")
            },
            //Open
            create() {
                this.creating = true
            },
            devolver() {
                this.devolviendo = true
            },
            update(item) {
                this.updating = true
                this.itemToEdit = item
            },
            show(item) {
                // Cargar siempre el movimiento completo desde el backend
                // para asegurarnos de tener los snapshots de producto
                this.itemToShow = null
                this.showing = true
                MovimientoProvider.findMovimiento(item.id)
                    .then(response => {
                        if (response && response.data && response.data.movimientoFind) {
                            this.itemToShow = response.data.movimientoFind
                        } else {
                            this.showing = false
                        }
                    })
                    .catch(e => {
                        console.error('Error cargando movimiento para mostrar', e)
                        this.showing = false
                    })
            },
            // remove(item) {
            //     this.deleting = true
            //     this.itemToDelete = item
            // },
            onFacturaEmitida(factura) {
                console.log('Factura emitida:', factura)
                this.$refs.list.fetch() // Refrescar lista para mostrar nuevo estado
            },
            onMensajeFactura(mensaje) {
                // Mostrar mensaje en snackbar
                this.flash = mensaje.texto
            },
            abrirModalFactura(movimiento) {
                this.intentarAbrirModalFactura(movimiento)
            },
            intentarAbrirModalFactura(movimiento) {
                if (!movimiento) return;
                const t = movimiento.tipo;
                if (t !== 'VENTA' && t !== 'DEVOLUCION') return;

                this.movimientoParaFacturar = movimiento
                this.$nextTick(() => {
                    this.mostrarModalFactura = true
                })
            }
        }
        
    }
</script>


